import { createSelector } from 'reselect';
import flow from 'lodash/fp/flow';

import { fullName } from '../../common/helpers/users';
import { getFirstLetter } from '../../common/helpers/customers';

export const getCustomerById = (state, id) => state.customers.byId[id];
export const getAllCustomers = state => state.customers.list.map(id => getCustomerById(state, id));
export const getLetter = state => state.customers.alphabetFilter;
export const getLettersPagination = state => state.customers.lettersPagination;

const filterCustomers = (customers, letter) => {
  if (!letter) {
    return customers;
  }
  return customers.filter(customer => letter === getFirstLetter(customer));
};

export const filteredCustomers = createSelector(
  [getAllCustomers, getLetter],
  filterCustomers
);

export const getCustomerName = flow(
  getCustomerById,
  fullName
);
